/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...


/*
sections.extend('slideshow', slideshowAutoExtension);

$(document).ready(function() {
    $('.hover').on('touchstart touchend', function(e) {
        e.preventDefault();
        $(this).toggleClass('hover_effect');
    });
});

$('.links').on('touchstart', function() {});
*/


/*service part image on hover action js*/
//on location
$(".img_slider_onlocation").on("mouseover", function (e) {
  $('#slideshow').html('<div class="slide_one slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/Knours_model-3_03dbbc95-2e05-49cb-8aad-62befac80619.jpg?v=1659896624" /></div> <div class="slide_two slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/onlocation-2.jpg?v=1659899030" /></div><div class="slide_three slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/fabian-3_c5f00d51-9f05-40a7-b0d6-68bf95286ae2.jpg?v=1660140240"/>');
    e.preventDefault()
});
//off location
$(".img_slider_offlocation").on("mouseover", function (e) {
  $('#slideshow').html('<div class="slide_one slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/483A0015_03023686-4972-406d-844f-c2e513d5c84f.jpg?v=1659746099" /></div> <div class="slide_two slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/shoot_light_shadow_bg_large_f98e2a6d-0c1b-405c-9416-875203e9bb1f.jpg?v=1659896949" /></div><div class="slide_three slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/outdoor-3.jpg?v=1659898412"/>');	
    e.preventDefault()
});
//Motion_graphic
$(".img_slider_motionGraphic").on("mouseover", function (e) {
  $('#slideshow').html('<div class="slide_one slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/motionGraphic1.gif?v=1660092625" /></div> <div class="slide_two slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/motionGraphic2.gif?v=1660093559" /></div><div class="slide_three slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/motionGraphic3.gif?v=1660093826"/>');	
    e.preventDefault()
});
//360 spin
$(".img_slider_360spin").on("mouseover", function (e) {
  $('#slideshow').html('<div class="slide_one slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/360spin-2-reduced.gif?v=1660131589" /></div> <div class="slide_two slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/360spin-1.gif?v=1660132091" /></div><div class="slide_three slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/motionGraphic3.gif?v=1660093826"/>');	
    e.preventDefault()
});
//casting
$(".img_slider_casting").on("mouseover", function (e) {
  $('#slideshow').html('<div class="slide_one slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/MG_0260.jpg?v=1661309239" /></div> <div class="slide_two slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/MG_0145.jpg?v=1661309877" /></div><div class="slide_three slide"><img class="slide_img" src="https://cdn.shopify.com/s/files/1/0592/5922/4217/files/MG_0025.jpg?v=1661309877"/>');	
    e.preventDefault()
});

jQuery(function($) {

    $(".service_ul").hover(
        function () {
            $(".omid").stop(true,true).css("transform","translate(-120%,0)")
        },
        function () {
            $(".omid").stop(true,true).css("transform","translate(0,0)")
        }
    );

});
  
/*end of service part image on hover action js*/


$(window).scroll(function() {
if ($(this).scrollTop() > 1){  
    $('#shopify-section-header').addClass("sticky");
  }
  else{
    $('#shopify-section-header').removeClass("sticky");
  }
});

//Portfolio slider 
var count = 0;
var directions = {
  prev: 0,
  next: 1
}

var prevButton = document.querySelector(".slider-navigation button:first-child");
var nextButton = document.querySelector(".slider-navigation button:last-child");
var sliders = document.querySelectorAll(".portfolio_slider figure");

initListeners();

function initListeners() {
  nextButton.addEventListener("click", onNavigationClick);
  prevButton.addEventListener("click", onNavigationClick);
}

function onNavigationClick(e) {
  var currentButton = e.target;
  var index = getElementIndex(e.target);
  var controlledCount = countController(index);
  
  var oldSlideItem = sliders[controlledCount.old];
  var newSlideItem = sliders[controlledCount.new];
  
  oldSlideItem.classList.remove("show");
  currentButton.classList.add("disabled");
  
  var showNextSliderItemInterval = setInterval(function() {
    newSlideItem.classList.add("show");
    currentButton.classList.remove("disabled");
    clearInterval(showNextSliderItemInterval);
  }, 500);
}

function countController(directionIndex) {
  var result = { new: 0, old: count };
  var max = sliders.length;
  
  if(directionIndex === directions.next) {
    count = count === max - 1 ? 0 : (count + 1);
  }
  
  if(directionIndex === directions.prev) {
    count = count === 0 ? (max - 1) : (count - 1);
  }
  
  result.new = count;
  
  return result;
}

function getElementIndex(element) {
  return Array.from(element.parentElement.children).indexOf(element);
}
//end of portfolio slider

/* ========================================== 
scrollTop() >= 300
Should be equal the the height of the header
========================================== */

$(window).scroll(function(){
    if ($(window).scrollTop() >= 41) {
        $('.section-header').addClass('fixed-header');
        $('#MainContent').addClass('visible');
    }
    else {
        $('.section-header').removeClass('fixed-header');
        $('#MainContent').removeClass('visible');
    }
});


